var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaintLine2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 55,
    viewBox: "0 0 117 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96 25.949C4.104 32.424.188 42.69 2.876 50.756c1.167 3.502 3.964 2.02 6.032.132 7.868-7.184 14.265-16.335 20.611-24.808 5.9-7.877 11.222-16.684 17.937-23.916C48.771.748 48.798 8.94 48.82 9.376c.435 8.695.219 17.411.97 26.092.167 1.928.034 5.91 1.705 7.395 1.553 1.381 5.23-.66 6.608-1.285 8.921-4.047 16.321-10.616 22.657-17.99 2.992-3.48 5.641-7.215 8.392-10.882.812-1.083 2.361-4.031 2.937-2.806.73 1.556.013 5.745.052 7.212a93.767 93.767 0 001.311 13.19c.062.366 1.34 9.234 2.832 8.759 1.998-.636 3.635-2.656 5.77-3.357 4.946-1.624 8.551-.508 13.111 1.102",
    stroke: "#10010D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
export default SvgPaintLine2;